<template lang="pug">
.inlineLayout
  slot
</template>


<script>

export default {
  name: "inlineLayout", 
};
</script>
<style lang="stylus" scoped>
.inlineLayout{
  display flex
  flex-direction row
  align-items center
}
</style>

